import {
  createRouter as createVueRouter,
  createWebHistory,
} from 'vue-router'

import routes from './routes/index.js'
import { registerGuards } from './guards/index.js'
import { baseUrl } from './location-params.js'
import { setMeta } from '@/router/default-routes-meta.js'

// HACK-VUE3
// It is designed for vue3 purposes. Just in case, we want to test this logic on vue2 only on development stage.
setMeta(routes)

// HACK-VUE3
function processParams (params) {
  if (params && (typeof params === 'object' || Array.isArray(params))) {
    const processedParams = Array.isArray(params) ? [] : {}
    for (const [key, value] of Object.entries(params)) {
      if (typeof value === 'object' || Array.isArray(value)) {
        processedParams[key] = JSON.stringify(value)
      } else {
        processedParams[key] = value
      }
    }
    return processedParams
  }
  return params
}

export function createRouter () {
  const router = createVueRouter({
    history: createWebHistory(baseUrl),
    routes,
    scrollBehavior () {
      return { top: 0 }
    },
  })

  // HACK-VUE3
  const originalPush = router.push
  router.push = function (location, onComplete, onAbort) {
    if (location.params) {
      location.params = processParams(location.params)
    }
    return originalPush.call(this, location, onComplete, onAbort)
  }

  // HACK-VUE3
  const originalReplace = router.replace
  router.replace = function (location, onComplete, onAbort) {
    if (location.params) {
      location.params = processParams(location.params)
    }
    return originalReplace.call(this, location, onComplete, onAbort)
  }

  registerGuards(router)

  return router
}

